import cmsAPI from '@/services/API/cmsAPI'

const buildParams = state => ({
  t: _.trim(state.search),
  page: state.currentPage,
})

const fetchCMSProviders = function({ commit,state }) {
  if(state.outDated){

    if (state.search != null && state.search !== '') {
      commit('SET_CURRENT_PAGE', 1);
    }

    const params = buildParams(state);

    commit('SET_LOADING', true);
    cmsAPI.fetchCMSProviders(params)
      .then(response=>{
        commit('SET_PROVIDERS', response.list);
        commit('SET_TOTAL_PROVIDERS', response.count);
        commit('SET_TOTAL_PAGES', response.pages);
        commit('SET_LOADING', false);
      })
  }
};

let searchTimeOut = null;
const setSearch = function({ dispatch, commit, state }, searchTerms) {
  commit('SET_SEARCH',searchTerms);
  clearTimeout(searchTimeOut)
  searchTimeOut = setTimeout(() => {
    commit('SET_CURRENT_PAGE', 1);
    dispatch('invalidate');
    return dispatch('fetchCMSProviders', buildParams(state));
  }, 300);
};

const fetchNextPage = function({commit, state, dispatch}) {
  if (state.currentPage < state.totalPages) {
    commit('SET_CURRENT_PAGE', state.currentPage + 1);
    dispatch('invalidate');
    dispatch('fetchCMSProviders');
  }
}

const fetchPreviousPage = function({commit, state, dispatch}) {
  if (state.currentPage > 1) {
    commit('SET_CURRENT_PAGE', state.currentPage - 1);
    dispatch('invalidate');
    dispatch('fetchCMSProviders');
  }
}

const invalidate = function({commit}) {
  commit('INVALIDATE')
}


export default {
  fetchCMSProviders,
  setSearch,
  fetchNextPage,
  fetchPreviousPage,
  invalidate,
};
